import React, { PureComponent, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { Player } from 'ThreeTerminal_pc/video';
import Chip from 'Chip';
const Video = errorBoundary(props => {
    return (
        <div className={styles.video_container}>
            <Player
                videoConfig={{
                    videoLargePoster: props.content[0].thumbnail,
                    videoPlayUrl: props.content[0].videoPlayUrl,
                    duration: +props.content[0].duration,
                    vid: props.content[0].guid,
                }}
                playermsg={{
                    width: 580,
                    height: 435,
                    autoPlay: true,
                }}
            />
        </div>
    );
});

const LeadNews = errorBoundary(props => {
    return (
        <a className={styles.title} href={props.content[0].url} target="_blank">
            {props.content[0].title}
        </a>
    );
});

const LeadNewsInfo = errorBoundary(props => {
    return (
        <a className={styles.news_info} target="_blank" href={props.content.url}>
            {props.content.content}
        </a>
    );
});

const ImportantNews = errorBoundary(props => {
    return (
        <div className={styles.news_list}>
            {props.content.map((item, index) => {
                return (
                    <div className={styles.news_item} key={index}>
                        <a className={styles.news_content} href={item.url} target="_blank">
                            {item.title}
                        </a>
                        <div className={styles.date}>{item.newsTime.split(' ')[0]}</div>
                    </div>
                );
            })}
        </div>
    );
});

class News extends PureComponent {
    static propTypes = {
        videoInfo: PropTypes.array,
        leadNews: PropTypes.array,
        leadNewsInfo: PropTypes.object,
        importantNews: PropTypes.array,
    };
    constructor(props) {
        super(props);

        this.state = {};
    }
    render() {
        const { videoInfo, leadNews, leadNewsInfo, importantNews } = this.props;

        return (
            <div className={styles.main_wrap}>
                <div className={styles.news}>
                    <Chip id="255257" type="recommend" title="视频" groupName="content" content={videoInfo}>
                        <Video />
                    </Chip>
                    <div className={styles.news_container}>
                        <Chip id="255256" type="recommend" title="头条" groupName="content" content={leadNews}>
                            <LeadNews />
                        </Chip>
                        <Chip id="230100" type="struct" title="头条描述" groupName="content" content={leadNewsInfo}>
                            <LeadNewsInfo />
                        </Chip>
                        <Chip id="225070" type="recommend" title="要闻" groupName="content" content={importantNews}>
                            <ImportantNews />
                        </Chip>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(News);
